import { Address, Button, DefinitionItem, DefinitionList, LoadingState, PhoneNumber, View } from "components/Shared";
import Datasource, { DatasourceResponse } from "lib/datasource";
import _ from "lodash";
import moment from "moment";
import React, { memo, useCallback, useEffect, useState } from "react";
import { RouteComponentProps } from "react-router";
import { withRouter } from "react-router-dom";
// import { Button } from "v2/components/shared";

interface Props extends RouteComponentProps {
	tenantId: string | number;
	editable?: boolean;
	name?: string;
	icon?: string;
}

const TenantTab = ({ tenantId, editable, history }: Props) => {
	const [, renderTrigger] = useState(moment());
	const [tenant, setTenant] = useState({} as any);
	const [datasource] = useState(
		new Datasource({ mainModelName: "tenant", renderTrigger: renderTrigger, includeRelationship: true })
	);

	const onClick = useCallback(() => history.push(`/tenants/${tenantId}/edit`), [history, tenantId]);
	useEffect(() => {
		let sub = datasource.responseSubject$.subscribe((response: DatasourceResponse) => {
			setTenant(response.normalizedMainModelResponse);
		});
		return () => sub.unsubscribe();
	}, [datasource]);

	useEffect(() => {
		if (!_.isEmpty(tenantId))
			datasource.get("v2", `tenants/${tenantId}`, {
				queryStringParameters: {
					fields: JSON.stringify({
						tenant: [
							"name",
							"trading_name",
							"phone_number",
							"contact_name",
							"contact_email",
							"contact_detail",
							"addresses",
							// Yardi identifiers (CustomerCode/CustomerName/BrandCode/BrandName)
							"customer_code",
							"customer_name",
							"brand_code",
							"brand_name"
						]
					})
				}
			});
	}, [datasource, tenantId]);

	if (datasource.isLoading) return <LoadingState />;

	if (!!tenant) {
		return (
			<View title={tenant.name}>
				<DefinitionList>
					<DefinitionItem title="trading_name" value={tenant.trading_name} />
					{/* Yardi identifiers — CustomerCode/CustomerName/BrandCode/BrandName. */}
					<DefinitionItem title="customer_code" value={tenant.customer_code} />
					<DefinitionItem title="customer_name" value={tenant.customer_name} />
					<DefinitionItem title="brand_code" value={tenant.brand_code} />
					<DefinitionItem title="brand_name" value={tenant.brand_name} />
					<DefinitionItem title="contact_detail" value={tenant.contact_detail} />
					<DefinitionItem title="contact_name" value={tenant.contact_name} />
					<DefinitionItem title="contact_email" value={tenant.contact_email} />
					<DefinitionItem title="phone_number" value={<PhoneNumber phone_number={tenant.phone_number} />} />
					{!!_.get(tenant, "addresses", []).length && (
						<DefinitionItem title="address">
							{_.map(tenant.addresses, address => (
								<Address key={address.id} address={address} />
							))}
						</DefinitionItem>
					)}
				</DefinitionList>
				{!!editable && <Button onClick={onClick}>Edit</Button>}
			</View>
		);
	}
	return null;
};

export default memo(withRouter(TenantTab));
